// extracted by mini-css-extract-plugin
export default {"empty":"Index_empty__3fIPp","button":"Index_button__UeMRe","wechat":"Index_wechat__jg71C","action":"Index_action__U8kO3","action_item":"Index_action_item__01dTS"};